import type { ClientMediaItem } from '@DigitaleDoerfer/digitale-doerfer-api';
import { PixelRatio } from 'react-native';

import type {
  AppMediaItem,
  AppMediaItemUrls
} from '@/features/media/types/mediaItem';
import { MediaItemSize } from '@/features/media/types/mediaItem';

/**
 * Todo: Future: if requested size is not available try to get next closest size
 */

/**
 * @param mediaItem media item form BE
 * @param mediaSize required media size. Default MediaItemSize.ORIGINAL
 * @returns Requested size if exists, original otherwise
 */
export const getSizedMediaItemUrl = (
  mediaItem: ClientMediaItem | undefined = undefined,
  mediaSize: MediaItemSize = MediaItemSize.ORIGINAL
): AppMediaItem => {
  if (mediaItem?.urls === undefined) return;

  const urls = mediaItem.urls;
  const original = urls.original;
  const mediaSizeUrls: AppMediaItemUrls = {
    thumbnail: urls.thumbnail ?? original,
    extraSmall: urls.extraSmall ?? original,
    small: urls.small ?? original,
    medium: urls.medium ?? original,
    large: urls.large ?? original,
    extraLarge: urls.extraLarge ?? original,
    original: original
  };

  return {
    ...mediaItem,
    url: mediaSizeUrls[mediaSize]
  };
};

/**
 * Returns the best-fitting media item size for a specified size.
 *
 * @param maxViewSize The maximum size of the view where the picture should be displayed.
 *
 * @see {@link https://erbenschell.iese.fraunhofer.de/DigitaleDoerfer/Backend-DigitalesDorf/-/blob/master/rest-application/src/main/resources/application.yml#L228}
 */
export const determineBestMediaItemSize = (maxViewSize: number) => {
  const maxPixelSize = PixelRatio.getPixelSizeForLayoutSize(maxViewSize);
  if (maxPixelSize <= 200) {
    return MediaItemSize.THUMBNAIL;
  } else if (maxPixelSize <= 640) {
    return MediaItemSize.EXTRA_SMALL;
  } else if (maxPixelSize <= 800) {
    return MediaItemSize.SMALL;
  } else if (maxPixelSize <= 1280) {
    return MediaItemSize.MEDIUM;
  } else if (maxPixelSize <= 1920) {
    return MediaItemSize.LARGE;
  } else if (maxPixelSize <= 2560) {
    return MediaItemSize.EXTRA_LARGE;
  } else {
    return MediaItemSize.ORIGINAL;
  }
};
